import axios from 'axios';
import WebApi from '../WebApi';
import { updateUrlGetParams } from '@/helpers/url';
class CalendarApi extends WebApi {
    async getAvailabilitiesData({ appointment_id, from, to, company_id, dt_week_start, dt_week_end }) {
        const urlParams = `?pagination[per_page]=100`;
        const { data } = await axios.get(`${this.urlPrefix}/availabilities${urlParams}`, {
            params: {
                appointment_id,
                from,
                to,
                company_id,
                dt_week_start,
                dt_week_end,
            },
        });
        return data;
    }
    async getMonthTimeslotDates({ appointment_id, from, to, company_id }) {
        const { data } = await axios.get(`${this.urlPrefix}/availabilities/timeslot_dates`, {
            params: {
                appointment_id,
                from,
                to,
                company_id,
            },
        });
        return Array.isArray(data) ? data : [];
    }
    async sendData({ company_name, client_surname, client_name, contract_number, location_value, company }) {
        return axios.post(`${this.urlPrefix}/some_endpoint`, {
            'user': {
                company_name,
                client_surname,
                client_name,
                contract_number,
                location_value,
                company,
            },
        });
    }
    async getCalendarViewData() {
        const { data } = await axios.get(`${this.urlPrefix}/calendar_view_settings`);
        return data;
    }
    async getCalendarInformation(url) {
        const { data } = await axios.get(`${this.urlPrefix}/${url}`);
        // info returned in different keys for all calendars =)
        return {
            data: data.site || data.hub || data.user || data.company,
            users: data.site ? data.site.users || [] : [],
        };
    }
    async getServicePointUsers(id) {
        const { data } = await axios.get(`${this.urlPrefix}/service_point_advisors?sp_id=${id}`);
        return data;
    }
    async getRemoteCredentials(id) {
        const { data } = await axios.get(`${this.urlPrefix}/remote_credentials?user_id=${id}`);
        return data;
    }
    async getMonthView({ date, meta, first_name, last_name, skill_ids = [], sort, id, calendar_type, }) {
        const { data } = await axios.get(`${this.urlPrefix}/month_views`, {
            params: {
                ...(calendar_type === `hub` && { 'hub_id': id }),
                ...(calendar_type === `branch` && { 'branch_id': id }),
                date,
                'pagination[page]': meta ? meta.next_page : 1,
                ...(skill_ids.length && { skill_ids }),
                ...(sort && { sort }),
                ...(first_name && { first_name }),
                ...(last_name && { last_name }),
            },
        });
        return data;
    }
    ;
    async getMonthServicePointView({ dt, sp_id }) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/service_point_month_views`, { dt, sp_id }));
        return data.month_views;
    }
    async getMonthServicePointUsersView({ sp_id }) {
        const { data } = await axios.get(updateUrlGetParams(`${this.urlPrefix}/service_point_advisors`, { sp_id }));
        return data.service_point_advisors;
    }
    async getFakeMonthData() {
        const { data } = await axios.get(`${this.urlPrefix}/dummy_datas/month_view`);
        return data;
    }
    ;
    async getMonthViewForUser({ date, user_id, id, calendar_type, }) {
        const { data } = await axios.get(`${this.urlPrefix}/month_views/day_details`, {
            params: {
                ...(calendar_type === `hub` && { 'hub_id': id }),
                ...(calendar_type === `branch` && { 'branch_id': id }),
                date,
                user_id,
            },
        });
        return data;
    }
    ;
    async getMonthViewShiftForDate({ dt, advisor_id, sp_id, }) {
        const { data } = await axios.get(`${this.urlPrefix}/service_point_month_views/shifts`, {
            params: {
                dt,
                sp_id,
                advisor_id,
            },
        });
        return data.shifts;
    }
    ;
    async getMonthViewRow({ date, user_id }) {
        const { data } = await axios.get(`${this.urlPrefix}/month_views/replace_row`, {
            params: {
                date,
                user_id,
            },
        });
        return data;
    }
    ;
}
const calendarApi = new CalendarApi();
export { calendarApi as CalendarApi, };
